<template>
  <div class="d-flex flex-column gap-12 mb-6">
    <!-- section 1 -->
    <divcard>
      <div class="txt-head black--text d-flex justify-space-between">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 4 :</span>
          การประเมินผลสำเร็จของโครงการ
        </div>
      </div>

      <div class="flex xs4 mb-2">
        <div class="txt-bigger2 mb-1 black--text">ผลสำเร็จของโครงการ</div>
        <div class="txt-normal mb-1 black--text">ประเมินผล</div>
      </div>
      <v-radio-group
        class="mt-0 pt-0"
        :value="form.evaluate_by"
        @change="setFormField('evaluate_by', $event)"
      >
        <div class="flex">
          <RadioItem class="mb-3" value="หน่วยงานผู้ดำเนินโครงการ">
            <div class="black--text">หน่วยงานผู้ดำเนินโครงการ</div>
          </RadioItem>
          <RadioItem class="mb-3" value="ผู้รับบริการ">
            <div class="black--text">ผู้รับบริการ</div>
          </RadioItem>
          <RadioItem class="mb-3" value="other">
            <div class="black--text">อื่นๆ (ระบุ)</div>
          </RadioItem>
          <div class="flex xs6">
            <TextField
              theme="3"
              :value="tempEvaluation"
              :disabled="form.evaluate_by != 'other'"
              :readonly="form.evaluate_by != 'other'"
              @onChange="tempEvaluation = $event"
            ></TextField>
          </div>
        </div>
      </v-radio-group>
      <div class="flex">
        <div class="mb-1 black--text">ผลประเมิน (ถ้ามี)</div>
        <TextArea
          theme="3"
          height="120"
          :value="form.evaluate_detail"
          @onChange="setFormField('evaluate_detail', $event)"
        ></TextArea>
      </div>
      <div class="flex xs4 mb-2">
        <div class="txt-normal mb-1 black--text">
          ร้อยละความพึงพอใจของผู้รับบริการ
        </div>
      </div>
      <v-radio-group
        class="mt-0 pt-0"
        :value="form.satisfaction"
        @change="setFormField('satisfaction', $event)"
      >
        <div class="d-flex gap-12">
          <RadioItem class="mb-3" :value="true">
            <div class="black--text">มี</div>
          </RadioItem>
          <RadioItem class="mb-3" :value="false">
            <div class="black--text">ไม่มี</div>
          </RadioItem>
        </div>
      </v-radio-group>
      <div class="flex">
        <div class="mb-1 black--text">ผลประเมิน (ถ้ามี)</div>
        <TextArea
          theme="3"
          height="120"
          :value="form.satisfaction_detail"
          @onChange="setFormField('satisfaction_detail', $event)"
        ></TextArea>
      </div>
    </divcard>

    <divcard>
      <div class="card-part pt-0">
        <div>
          <div class="txt-head black--text mb-5">
            2. ปัญหาและอุปสรรคการดำเนินโครงการ
            <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
          </div>

          <div class="flex gap-16">
              <TextArea
                theme="3"
                height="120"
                :value="form.problem"
                @onChange="setFormField('problem', $event)"
              ></TextArea>
          </div>
        </div>
      </div>
    </divcard>

    <divcard>
      <div class="txt-head black--text mb-5">
        3. ข้อสังเกต ข้อเสนอแนะ และประเด็นที่ต้องติดตาม
        <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
      </div>

      <div class="flex gap-16">
          <TextArea
            theme="3"
            height="120"
            :value="form.recommendation"
            @onChange="setFormField('recommendation', $event)"
          ></TextArea>
      </div>
    </divcard>
  </div>
</template>

<script>
import TextField from "../../../components/input/TextField";
import TextArea from "../../../components/input/TextArea";
import Button from "../../../components/input/Button";
import { eventBus } from "../../../plugins/global-funcs";
import { mapState } from "vuex";
import RadioItem from "@/components/input/RadioItem";

export default {
  name: "BFormOOI",
  components: {
    TextField,
    TextArea,
    Button,
    RadioItem,
  },
  props: {
    masterData: {
      default: () => ({}),
    },
    isSameId: {
      default: false,
    },
  },
  data() {
    return {
      form: {},
      tempEvaluation: "",
      expanded: false,
    };
  },
  created() {
    if (this.masterData) {
      this.setData();
    }
    eventBus.$on("fundamentalFormSuccessEvaluation", () => {
      this.form.evaluate_by = this.form.evaluate_by == 'other'
        ? this.tempEvaluation
        : this.form.evaluate_by;
      eventBus.$emit("fundamentalFormSuccessEvaluationSend", {
        ...this.form,
      });
    });

    eventBus.$on("fundamentalFormSuccessEvaluationSetData", () => this.setData());
  },
  methods: {
    setFormField(field, val) {
      this.form[field] = val;
      this.$forceUpdate();
    },
    setData() {
      console.log("setData fundamentalFormSuccessEvaluati", this.masterData);

        this.form.evaluate_by = this.masterData.formFund?.evaluate_by || "";
        this.form.evaluate_detail = this.masterData.formFund?.evaluate_detail || "";
        this.tempEvaluation = this.masterData.formFund?.evaluate_by;
        this.form.satisfaction = this.masterData.formFund?.satisfaction || false;
        this.form.satisfaction_detail = this.masterData.formFund?.satisfaction_detail || "";
        this.form.problem = this.masterData.formFund?.problem || "";
        this.form.recommendation = this.masterData.formFund?.recommendation || "";
    },
  },
};
</script>

<style scoped></style>
